// Default actions that are selectable in the Action bar
export enum ModuleSendSelectAction {
  SelectPoly = 'selectPoly',
  CreateEditPoly = 'createEditPoly',
  DeleteSelectedPoly = 'deletePoly',
  MagicWand = 'magicWand',
  ColorChecker = 'colorChecker',
  Undo = 'undo',
  Redo = 'redo',
  ZoomWorkspace = 'zoomWorkspace',
  ZoomInnerfit = 'zoomInnerfit',
  ZoomSelection = 'zoomSelection',
  AddGrid = 'addGrid',
  EditGrid = 'editGrid',
  UseBrush = 'useBrush',
  UsePatternBrush = 'usePatternBrush',
  UseRubber = 'useRubber',
  AddRect = 'addRect',
  EditRect = 'editRect',
  DeleteSelectedRect = 'deleteRect',
  AddEllipse = 'addEllipse',
  EditEllipse = 'editEllipse',
  DeleteSelectedEllipse = 'deleteEllipse',
}

// Actions we are going to send
export enum ModuleSendAction {
  SelectElement = 'selectElement',
  RenameElement = 'renameElement',
  MoveElement = 'moveElement',
  DeleteElement = 'deleteElement',
  HoverElement = 'hoverOnElement',
  HoverOffElement = 'hoverOffElement',

  SelectLayer = 'selectLayer',
  RenameLayer = 'renameLayer',
  MoveLayer = 'moveLayer',
  DeleteLayer = 'deleteLayer',
  HoverLayer = 'hoverOnLayer',
  HoverOffLayer = 'hoverOffLayer',

  LoadPicture = 'loadPicture',
  AddElement = 'addElement',
  DoBooleanOperation = 'doBoolean',
  ZoomPercentage = 'zoom',
  LimitToMask = 'limitToMask',
  GetModuleState = 'getStatus',

  SetMaterial = 'setMaterial',
  ColorChecker = 'colorchecker',
}

export enum ModuleSendBrushShapeAction {
  BrushShape = 'brushType',
  RubberShape = 'rubberType',
  PatternBrushShape = 'patternBrushType',
}

export enum ModuleSendBrushSizeAction {
  BrushSize = 'brushSize',
  RubberSize = 'rubberSize',
  PatternBrushSize = 'patternbrushSize',
}

// Actions we are going to receive
export enum ModuleReceiveAction {
  Ready = 'ready',
  ProjectLoaded = 'tokenloaded',
  StatusSync = 'status',
  CommandReceived = 'commandreceived',
  NewLayer = 'newlayer',
  HoverOffObject = 'hoverofflayer',
  HoverObject = 'hoveronlayer',
}
